document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".edito-stories")?.forEach((section) => {
    const stories = section.querySelector(".orsay-stories");
    if (!stories) return;

    section
      .querySelectorAll(".edito-stories__card-story")
      ?.forEach((cardStory, index) => {
        const video = cardStory.querySelector("video");
        if (!video) return;
        cardStory.addEventListener("mouseenter", () => {
          video.play();
        });
        cardStory.addEventListener("mouseleave", () => {
          video.pause();
          video.currentTime = 0;
        });
        cardStory.addEventListener("click", (event) => {
          stories.querySelector(
            ".orsay-stories__feed-container"
          ).style.transformOrigin = `${event.clientX}px ${event.clientY}px`;
          stories.goToStory(index);
          stories.show();
        });
      });
  });
});
